export default __webpack_public_path__ + "static/media/RightArrow.b4b0fc44.svg";